// store/plugins/subscriptionPlugin.js
import { v4 as uuidv4 } from 'uuid'
import apolloClient from '@/packages/apollo-client'
import { SUBSCRIBE_TO_EVENTS } from '@/store/modules/WebSocket/action-types'
import { SET_SESSION_ID } from '@/store/modules/WebSocket/mutation-types'


export default function subscriptionPlugin (store) {
	let sub = null

	let sessionId = localStorage.getItem('sessionId') || uuidv4()
	localStorage.setItem('sessionId', sessionId)
	store.commit(`WebSocket/${SET_SESSION_ID}`, sessionId)

	const initSubscription = async () => {
		// clean previous
		if (sub?.unsubscribe) sub.unsubscribe()

		sub = await store.dispatch(`WebSocket/${SUBSCRIBE_TO_EVENTS}`, {
			sessionId,
			types: ['CONFIRM_PART_PICTURES_UPLOAD', 'CONFIRM_GROUPED_SALE_PICTURES_UPLOAD', 'EXTRACT_DATA_FROM_VIN', 'CREATE_GROUPED_SALE_PARTS_FROM_DRAFT', 'ERROR']
		})
	}

	// start it
	initSubscription()

	// re-subscribe on logout (new session)
	store.subscribe(async (mutation) => {
		if (mutation.type === 'Auth/logout') {
			if (sub?.unsubscribe) sub.unsubscribe()

			if (apolloClient) {
				try {
					await apolloClient.cache.reset()
				} catch (err) {
					console.warn('Apollo cache reset failed:', err)
				}
			}

			const newSessionId = uuidv4()
			sessionId = newSessionId
			localStorage.setItem('sessionId', newSessionId)
			store.commit(`WebSocket/${SET_SESSION_ID}`, newSessionId)
			await initSubscription()
		}
	})

	// clean up on unload
	if (typeof window !== 'undefined') {
		const onUnload = () => {
			if (sub?.unsubscribe) sub.unsubscribe()
			window.removeEventListener('beforeunload', onUnload)
		}
		window.addEventListener('beforeunload', onUnload)
	}
}
